var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c("div", { staticClass: "bg-gray2 pb-1" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c(
            "div",
            { staticClass: "d-flex justify-content-between align-items-end" },
            [
              _c("ob1-breadcrumb", {
                staticClass: "me-2 breadcrumb-full",
                staticStyle: { "min-width": "0" },
                attrs: { items: _vm.breadcrumbItems },
              }),
              _vm._v(" "),
              _c("cart-banner", {
                staticClass: "py-1",
                attrs: {
                  "cart-link": _vm.cartUrl,
                  "number-of-items": _vm.accessoriesInCartCount,
                  "cart-enabled": !!_vm.cartUrl,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-column flex-md-row mb-1 header" },
            [
              _c("h1", { staticClass: "mb-0 me-md-1" }, [
                _vm.bannerAndBrand
                  ? _c("span", { staticClass: "h3 fw-normal" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.bannerAndBrand)
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v(_vm._s(_vm.currentVersion.name))]),
              ]),
              _vm._v(" "),
              _vm.displayRatings
                ? _c("Rating", {
                    staticClass: "item-summary align-items-end mb-md-1 m-0",
                    attrs: {
                      average: _vm.currentVersion.reviewsStats.average,
                      text:
                        "(" + _vm.currentVersion.reviewsStats.count + " avis)",
                      "rating-results-height": 1.375,
                      link: "#anchor-reviews",
                    },
                    on: {
                      "ob1-rating-link": function ($event) {
                        $event.preventDefault()
                        return _vm.scrollToPageMenuAnchor("anchor-reviews")
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-column flex-md-row bg-white" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column info-device-width border-right-md border-gray2",
                },
                [
                  _c(
                    "div",
                    { staticClass: "px-1 px-lg-2 py-1" },
                    [
                      _c(
                        "div",
                        { staticClass: "item-img" },
                        [
                          _c("ob1-carrousel", {
                            key: "device-gallery-" + _vm.currentVersion.seoId,
                            attrs: {
                              id: "device-gallery",
                              images: _vm.currentVersion.images,
                              "is-product-sheet": true,
                              "is-device-product-sheet": true,
                              "with-zoom": true,
                              "with-thumbnails": true,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.currentVersion.asilage
                        ? _c("ob1-separateur", { staticClass: "my-1" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVersion.asilage
                        ? _c("asilage", {
                            attrs: {
                              title: _vm.currentVersion.asilage.title,
                              condition: _vm.currentVersion.asilage.condition,
                              "form-url": _vm.currentVersion.asilage.formUrl,
                              image: _vm.currentVersion.asilage.image,
                              "condition-label":
                                _vm.currentVersion.asilage.conditionLabel,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "w-100" }, [
                _c(
                  "div",
                  { staticClass: "px-1 px-md-2 py-1" },
                  [
                    _c(
                      "fieldset",
                      [
                        _c("legend", { staticClass: "visually-hidden" }, [
                          _vm._v(
                            "\n                                Couleur\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("ColorChips", {
                          staticClass: "mb-1",
                          attrs: {
                            id: "colors",
                            "selected-color": _vm.currentVersion.color
                              ? _vm.currentVersion.color.code
                              : null,
                            colors: _vm.allColors,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeVariant("color", $event.code)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.dto.allVariants, function (variant, index) {
                      return _c(
                        "fieldset",
                        {
                          key: index,
                          class: _vm.numberOfColors > 0 ? "mb-1" : "mt-1 mb-1",
                        },
                        [
                          _c("legend", { staticClass: "visually-hidden" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(variant.name) +
                                "\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(variant.values, function (value, valueIndex) {
                            return _c("ob1-chips", {
                              key: "variant-" + index + "-" + valueIndex,
                              attrs: {
                                id: "variant-" + index + "-" + valueIndex,
                                "is-choice-version": true,
                                label: value,
                                "is-disabled":
                                  index === _vm.dto.allVariants.length - 1 &&
                                  !_vm.hasVariantEnabled(variant.name, value),
                                "is-checked":
                                  _vm.hasCurrentVersionVariantChecked(
                                    variant.name,
                                    value
                                  ),
                                "disable-uncheck": true,
                              },
                              on: {
                                "ob1-chips-click": function ($event) {
                                  return _vm.changeVariant(variant.name, value)
                                },
                              },
                            })
                          }),
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _vm.allGrades.length > 0
                      ? _c(
                          "fieldset",
                          { staticClass: "mt-1" },
                          [
                            _c("legend", { staticClass: "visually-hidden" }, [
                              _vm._v(
                                "\n                                Etat du mobile Reconditionné\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.allGrades, function (grade, index) {
                              return _c("ob1-chips", {
                                key: "grade-" + index,
                                attrs: {
                                  id: "grade-" + index,
                                  "is-choice-version": true,
                                  label: grade.label,
                                  "is-disabled": false,
                                  "is-checked": grade.isChecked,
                                  "additional-classes": "mb-1",
                                  "disable-uncheck": true,
                                },
                                on: {
                                  "ob1-chips-click": function ($event) {
                                    return _vm.changeVariant(
                                      "grade",
                                      grade.label
                                    )
                                  },
                                },
                              })
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.allGrades.length > 0
                      ? [
                          _c("ob1-liens", {
                            attrs: {
                              text: "Pour en savoir plus, c'est par ici",
                              "is-button": "",
                              "data-bs-toggle": "modal",
                              "modal-id": "gradeModal",
                              "with-arrow": "",
                              "data-oevent-category":
                                "comment_choisir_son_reconditionne",
                              "data-oevent-action": _vm.getGradePopinAction(),
                              "data-oevent-label": "vers_popin",
                            },
                          }),
                          _vm._v(" "),
                          _c("grade-popin", {
                            attrs: {
                              "modal-id": "gradeModal",
                              "default-grade-id": _vm.checkedGrade?.code,
                              labels: _vm.gradeLabels,
                            },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.allBatteries.length > 0
                      ? _c(
                          "fieldset",
                          { staticClass: "mt-1" },
                          [
                            _c("legend", { staticClass: "visually-hidden" }, [
                              _vm._v(
                                "\n                                Etat de la batterie\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.allBatteries, function (battery, index) {
                              return _c("ob1-chips", {
                                key: "battery-" + index,
                                attrs: {
                                  id: "battery-" + index,
                                  "is-choice-version": true,
                                  label: battery.label,
                                  "is-disabled": !_vm.hasVariantEnabled(
                                    "battery",
                                    battery.label
                                  ),
                                  "is-checked": battery.isChecked,
                                  "additional-classes": "mb-1",
                                  "disable-uncheck": true,
                                },
                                on: {
                                  "ob1-chips-click": function ($event) {
                                    return _vm.changeVariant(
                                      "battery",
                                      battery.label
                                    )
                                  },
                                },
                              })
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ob1-separateur", { staticClass: "my-1" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-lg-flex justify-content-between" },
                      [
                        _c("device-detail-price", {
                          attrs: {
                            "device-price": _vm.currentVersion.price,
                            "is-price-inversion-enabled":
                              _vm.dto.priceInversionEnabled,
                            "loan-rate-zero-label": _vm.dto.loanRateZeroLabel,
                            "loan-rate-zero-offer-label":
                              _vm.dto.loanRateZeroOfferLabel,
                            "funding-details": _vm.fundingDetails,
                            "show-guarantee-legal-mentions":
                              _vm.currentVersion.showGuaranteeLegalMentions,
                            "guarantee-legal-mentions-label":
                              _vm.currentVersion.guaranteeLegalMentionsLabel,
                            "advantage-messages": _vm.dto.advantageMessages,
                            "pxf-legal-mentions-text":
                              _vm.shouldDisplayPXFMention
                                ? _vm.dto.pxfMention
                                : null,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.currentVersion.advantages
                      ? _c("refunds", {
                          staticClass: "mb-1",
                          attrs: {
                            odrs: _vm.currentVersion.advantages.odrData,
                            "device-seo-id": _vm.currentVersion.seoId,
                            "refund-messages": _vm.dto.refundMessages,
                            "total-amount-in-cents":
                              _vm.currentVersion.advantages.totalAmountInCents,
                            "advantages-label":
                              _vm.currentVersion.advantages.label,
                            recovery: _vm.currentVersion.advantages.recovery,
                            "simulator-modal-id": _vm.simulatorModalId,
                            "simulator-result-modal-id":
                              _vm.savedSimulationResultModalId,
                            "recovery-modal-id": _vm.recoveryModalId,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRecovery
                      ? [
                          _c("mobile-recovery-simulator-modal", {
                            attrs: {
                              "modal-id": _vm.simulatorModalId,
                              shop: _vm.dto.shop,
                              messages:
                                _vm.dto.refundMessages.recoverySimulator,
                            },
                            on: {
                              "update-recovery-simulation":
                                _vm.updateRecoveryPrice,
                            },
                          }),
                          _vm._v(" "),
                          _vm.currentVersion.advantages.recovery
                            .manualEstimation
                            ? _c("mobile-recovery-simulation-result-modal", {
                                attrs: {
                                  "modal-id": _vm.savedSimulationResultModalId,
                                  shop: _vm.dto.shop,
                                  messages:
                                    _vm.dto.refundMessages.recoverySimulator
                                      .result,
                                  "estimated-device-price-in-cents":
                                    _vm.currentVersion.advantages.recovery
                                      .amountInCents,
                                  "estimated-device-model":
                                    _vm.currentVersion.advantages.recovery
                                      .deviceModel,
                                  bonus:
                                    _vm.currentVersion.advantages.recovery
                                      .bonus,
                                  "online-recovery-available":
                                    _vm.onlineRecoveryAvailable,
                                },
                                on: {
                                  "new-simulation": _vm.newSimulation,
                                  "save-simulation": _vm.saveSimulation,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("mobile-recovery-simulation-result-modal", {
                            attrs: {
                              "modal-id": _vm.currentSimulationResultModalId,
                              shop: _vm.dto.shop,
                              messages:
                                _vm.dto.refundMessages.recoverySimulator.result,
                              "estimated-device-price-in-cents":
                                _vm.estimatedDevice.recoveryPriceInCents,
                              "estimated-device-model":
                                _vm.estimatedDevice.model,
                              bonus:
                                _vm.currentVersion.advantages.recovery.bonus,
                              "online-recovery-available":
                                _vm.onlineRecoveryAvailable,
                            },
                            on: {
                              "new-simulation": _vm.newSimulation,
                              "save-simulation": _vm.saveSimulation,
                            },
                          }),
                          _vm._v(" "),
                          _c("mobile-recovery-details-modal", {
                            attrs: {
                              "modal-id": _vm.recoveryModalId,
                              "infos-recovery":
                                _vm.dto.refundMessages.recoveryModal
                                  .infosRecovery,
                              "online-recovery": _vm.onlineRecoveryAvailable
                                ? _vm.dto.refundMessages.recoveryModal
                                    .onlineRecovery
                                : null,
                              "store-recovery": _vm.eligibleEresa
                                ? _vm.dto.refundMessages.recoveryModal
                                    .storeRecovery
                                : null,
                              "bonus-recovery":
                                _vm.dto.refundMessages.recoveryModal
                                  .bonusRecovery,
                              bonus:
                                _vm.currentVersion.advantages.recovery.bonus,
                              "recovery-simulator":
                                _vm.dto.refundMessages.recoverySimulator,
                              "simulator-button-label":
                                _vm.dto.refundMessages.simulatorButtonLabel,
                              "bonus-amount": _vm.bonusAmountFormat,
                              "simulator-modal-id": _vm.simulatorModalId,
                            },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentVersion.inStock
                      ? [
                          _vm.isLoading
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "item-spinner d-flex justify-content-center",
                                },
                                [
                                  _c("ob1-progress-indicators", {
                                    attrs: { size: 50, type: "undetermined" },
                                  }),
                                ],
                                1
                              )
                            : _c("ob1-boutons", {
                                ref: "add-device-cta",
                                staticClass: "mt-1",
                                attrs: {
                                  label: "Ajouter au panier",
                                  "is-primary": true,
                                },
                                on: { "ob1-boutons-click": _vm.onAddToCart },
                              }),
                        ]
                      : _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c("ob1-message-alerte", {
                              staticClass: "col-12 pt-2",
                              attrs: {
                                "is-simple-alerte": false,
                                title: _vm.dto.alertStatusMessages.title,
                                text: _vm.dto.alertStatusMessages.message,
                                type: "warning",
                              },
                            }),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-2" },
                      [
                        _c("sold-by-card", {
                          attrs: {
                            title: _vm.sellerLabel,
                            "sold-by-orange": _vm.currentVersion.firstParty,
                            "info-lines": _vm.deliveryLabels,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.shouldShowDasBatteryOrEnergyLabelBlock
        ? _c("div", { staticClass: "bg-gray2" }, [
            _c("div", { staticClass: "container-fluid" }, [
              _c(
                "div",
                { staticClass: "row align-items-center pb-1" },
                [
                  _vm.currentVersion.das
                    ? _c(
                        "div",
                        { staticClass: "col-12 col-md-auto" },
                        [
                          _c("das", {
                            staticClass: "my-1",
                            attrs: {
                              head: _vm.currentVersion.das.head,
                              trunk: _vm.currentVersion.das.trunk,
                              member: _vm.currentVersion.das.member,
                              prefix: _vm.currentVersion.das.prefix,
                              "popin-title": _vm.currentVersion.das.popinTitle,
                              "popin-text":
                                _vm.currentVersion.das.popinDescription,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVersion.chargerInfos
                    ? [
                        _vm.currentVersion.chargerInfos.chargerIncluded
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-md-auto my-1 my-md-0 mx-md-2 px-md-0",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "icon icon-charger-availability charger-icon-size ps-1 ps-md-0 text-gray4",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                    _vm._v(" "),
                                    _c("strong", {
                                      staticClass: "ps-3 ps-md-0",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.currentVersion.chargerInfos
                                            .chargerIncludedMessage
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm.currentVersion.chargerInfos
                              .chargerCompatibleInfos
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-md-auto my-1 my-md-0 mx-md-2 px-md-0",
                              },
                              [
                                _c("ChargerInfos", {
                                  attrs: {
                                    "charger-infos":
                                      _vm.currentVersion.chargerInfos
                                        .chargerCompatibleInfos,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVersion.energyLabel
                    ? _c(
                        "div",
                        { staticClass: "col-12 col-md-auto" },
                        [
                          _c("energy-label", {
                            attrs: {
                              id: _vm.currentVersion.seoId,
                              "energy-label": _vm.currentVersion.energyLabel,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldDisplayPXFMention
        ? _c(
            "section",
            { staticClass: "container-fluid" },
            [
              _c("div", { staticClass: "row mt-2 mb-1" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("financing-mentions", {
                      attrs: {
                        "financing-mentions": _vm.dto.financingMentions,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.crossSellAccessories.length === 0
                ? _c("ob1-separateur", { staticClass: "my-2 mb-1" })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loadingCrossSell
        ? _c(
            "div",
            {
              class: [
                "bg-gray2",
                _vm.shouldShowDasBatteryOrEnergyLabelBlock ? "py-1" : "py-2",
              ],
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-content-center" },
                [
                  _c("ob1-progress-indicators", {
                    staticClass: "my-auto",
                    attrs: { size: 50, type: "undetermined" },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.crossSellAccessories.length > 0
        ? _c(
            "div",
            {
              class: [
                "bg-gray2",
                _vm.shouldShowDasBatteryOrEnergyLabelBlock ? "py-1" : "py-2",
              ],
            },
            [
              _c(
                "section",
                { staticClass: "container-fluid bg-white py-1" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("CrossSellAccessories", {
                    attrs: {
                      "accessory-ctrl": _vm.marketplaceCtrl,
                      "compact-promo-messages-dto":
                        _vm.dto.compactPromoMessages,
                      "advantage-messages": _vm.dto.advantageMessages,
                      "das-dto": _vm.dto.dasLabel,
                      accessories: _vm.crossSellAccessories,
                      "seller-shop-name": "Orange",
                    },
                    on: {
                      "accessory-updated": _vm.onCrossSellUpdated,
                      "accessory-error": _vm.onCrossSellError,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid mt-2" },
        [
          _vm.currentVersion.descriptionTitle
            ? _c("p", { staticClass: "lead text-mw mb-0" }, [
                _c("strong", [
                  _vm._v(_vm._s(_vm.currentVersion.descriptionTitle)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentVersion.description
            ? _c("p", {
                staticClass: "text-mw",
                domProps: { innerHTML: _vm._s(_vm.currentVersion.description) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pageMenu.tabs.length > 0
            ? _c("ob1-page-menu", {
                staticClass: "sticky bg-white mb-2",
                attrs: { id: "device-details-page-menu", tabs: _vm.tabs },
                on: { "ob1-page-menu-click": _vm.scrollToPageMenuAnchor },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.currentVersion.zigZag || _vm.currentVersion.longDescription
            ? _c(
                "section",
                [
                  _c("div", { staticClass: "mb-xl-3" }),
                  _vm._v(" "),
                  _c("header-signature", {
                    attrs: { text: _vm.essentialTitle },
                  }),
                  _vm._v(" "),
                  _vm.currentVersion.zigZag
                    ? _c("EditorialPush", {
                        attrs: {
                          zigzag: _vm.currentVersion.zigZag,
                          "with-image-resize": !_vm.currentVersion.firstParty,
                        },
                      })
                    : _vm.currentVersion.longDescription
                    ? _c("div", [
                        _c("p", {
                          attrs: { id: "anchor-zig-zag" },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.currentVersion.longDescription
                            ),
                          },
                        }),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentVersion.technicalFeatures
            ? _c(
                "section",
                [
                  _vm.currentVersion.zigZag ||
                  _vm.currentVersion.longDescription
                    ? _c("ob1-separateur", { staticClass: "my-2 mb-xl-3" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("accessory-technical-features", {
                    attrs: {
                      "is-first-party": _vm.currentVersion.firstParty,
                      "accessory-features":
                        _vm.currentVersion.technicalFeatures,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRecovery
            ? [
                _c(
                  "section",
                  { staticClass: "mb-2 mb-md-3" },
                  [
                    _c("ob1-separateur", { staticClass: "my-2" }),
                    _vm._v(" "),
                    _c("header-signature", {
                      attrs: { text: _vm.dto.recoveryMessages.messages.title },
                    }),
                    _vm._v(" "),
                    _c("mobile-recovery", {
                      attrs: {
                        id: "anchor-mobile-recovery",
                        "recovery-amount-in-cents":
                          _vm.currentVersion.advantages.recovery.amountInCents,
                        "recovery-device-model":
                          _vm.currentVersion.advantages.recovery.deviceModel,
                        "manual-estimation":
                          _vm.currentVersion.advantages.recovery
                            .manualEstimation,
                        "bonus-amount-in-cents": _vm.bonusAmountInCents,
                        "simulator-modal-id": _vm.simulatorModalId,
                        "recovery-modal-id": _vm.recoveryModalId,
                        messages: _vm.dto.recoveryMessages.messages,
                        visual: _vm.dto.recoveryMessages.visual,
                        shop: _vm.dto.shop,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.currentVersion.showGuaranteeLegalMentions
            ? _c(
                "section",
                [
                  _c("ob1-separateur", { staticClass: "my-2 mb-xl-3" }),
                  _vm._v(" "),
                  _c("guarantee-legal-mentions", {
                    attrs: {
                      "legal-mentions": _vm.currentVersion.deviceLegalMentions,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.displayRatings
            ? [
                _c(
                  "section",
                  { staticClass: "mb-md-3" },
                  [
                    _vm.currentVersion.showGuaranteeLegalMentions
                      ? _c("ob1-separateur", { staticClass: "my-2" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("header-signature", {
                      attrs: { text: _vm.reviewsMessages.title },
                    }),
                    _vm._v(" "),
                    _c("device-average-rating-reviews", {
                      attrs: {
                        "reviews-stats-average":
                          _vm.currentVersion.reviewsStats.average,
                        "review-count": _vm.currentVersion.reviewsStats.count,
                        "reviews-messages": _vm.reviewsMessages,
                        summary: _vm.currentVersion.summary,
                      },
                    }),
                    _vm._v(" "),
                    _c("device-filter-and-details-reviews", {
                      attrs: {
                        "device-details-reviews": _vm.deviceDetailsReviews,
                        "total-review-count":
                          _vm.currentVersion.reviewsStats.count,
                        "device-filter-reviews": _vm.deviceFilterReviews,
                        "reviews-messages": _vm.reviewsMessages,
                        "ratings-filter-checkboxes":
                          _vm.ratingsFilterCheckboxes,
                        "date-sort-radio-buttons": _vm.dateSortRadioButtons,
                      },
                      on: {
                        "update-ratings-filter-handler":
                          _vm.updateRatingsFilterHandler,
                        "review-date-sort-item-click":
                          _vm.reviewDateSortHandler,
                        "more-device-reviews": _vm.getMoreDeviceReviews,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.currentVersion.environmentalQuality
            ? _c("ob1-liens", {
                staticClass: "mw-100 py-0",
                attrs: {
                  href: _vm.currentVersion.environmentalQuality.url,
                  text: _vm.currentVersion.environmentalQuality.linkLabel,
                  "with-arrow": true,
                  "is-mini": true,
                  target: "_blank",
                },
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.currentVersion.price.price.paymentInfoLabel &&
      _vm.currentVersion.price.price.paymentInfoLabel.type === "CB4X"
        ? _c("div", { staticClass: "bg-gray2 mt-1 pt-1 pb-1" }, [
            _c(
              "div",
              { staticClass: "container-fluid" },
              [
                _c("legal-mentions4x-cb", {
                  attrs: {
                    label: _vm.dto.cb4xMention.label,
                    "popin4x-cb": _vm.dto.cb4xMention.cb4xPopin,
                    "pxf-legal-mentions-text": _vm.dto.pxfMention,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ob1-snack-bar", {
        ref: "snackbar",
        attrs: {
          id: "snackbar",
          icon: "icon-error-severe",
          label: _vm.errorMessage,
        },
      }),
      _vm._v(" "),
      _c(
        "ob1-popin-modal2",
        {
          attrs: {
            id: "add-to-cart-popin",
            "aria-labelledby": "add-to-cart-popin-label",
            "show-close-button": false,
          },
        },
        [
          _c("AlertMessage", {
            attrs: {
              id: "add-to-cart-popin-label",
              title: _vm.dto.cartMessages.addSuccess,
              type: "success",
            },
          }),
          _vm._v(" "),
          _vm.cartPaymentChange
            ? _c("AlertMessage", {
                attrs: {
                  title: _vm.dto.cartMessages.paymentChangeTitle,
                  text: _vm.dto.cartMessages.paymentChangeText,
                  type: "info",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex justify-content-center" }, [
            _c(
              "div",
              { staticClass: "d-flex flex-column" },
              [
                _c("ob1-boutons", {
                  staticClass: "my-2",
                  attrs: {
                    "data-bs-dismiss": "modal",
                    label: "Continuer vos achats",
                    "is-secondary": true,
                  },
                }),
                _vm._v(" "),
                _c("ob1-boutons", {
                  attrs: {
                    label: "Voir votre panier",
                    href: _vm.cartUrl,
                    "is-button": false,
                    "is-primary": true,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("ob1-snack-bar", {
        ref: "savedSimulationSnackbar",
        attrs: {
          id: "simulation-snackbar",
          icon: "icon-tick-circle",
          label: _vm.dto.refundMessages.recoverySimulator.result.snackbarLabel,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h2", [_vm._v("Accessoirement, vous n'oubliez rien ?")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }